<template>
  <div>
    <media-library-attachment
        route-prefix="transient-uploads"
        @change="onChange"
        :validation-rules="validationRules"
        :multiple="multiple"
        :max-items="maxItems"
        :initial-value="initialValue"
        :name="name"
        file-type-help-text="PDF, DOC and DOCX files only"
    >
      <template
          slot="fields"
          slot-scope="{
            getCustomPropertyInputProps,
            getCustomPropertyInputListeners,
            getCustomPropertyInputErrors,
            getNameInputProps,
            getNameInputListeners,
            getNameInputErrors,
        }"
      >
        <div class="media-library-property">
          {{ getNameInputProps().value }}
        </div>
      </template>
    </media-library-attachment>
  </div>
</template>

<script>
import { MediaLibraryAttachment } from 'media-library-pro-vue2-attachment'

export default {
  components: {
    MediaLibraryAttachment
  },
  props: {
    name: {
      type: String,
      required: true
    },
    maxItems: {
      type: Number,
      required: false,
      default: 1
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    maxFileSize: {
      type: Number,
      required: false
    },
    initialValue: {
      required: false,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    onChange (media) {
      this.$emit('input', media)
    }
  },
  computed: {
    validationRules () {
      return {
        accept: [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ],
        maxSizeInKB: this.maxFileSize || 10240
      }
    }
  }
}
</script>
